export class BenefitVerification {
  id: number;
  aasmState: string;
  createdAt: Date;
  verifiedAt: Date;
  patientInsuranceId: number;

  load_from_json(json: any): BenefitVerification {
    this.id = json.id;
    this.aasmState = json.aasmState;
    this.createdAt = json.createdAt && new Date(json.createdAt);
    this.verifiedAt = json.verificationDate && new Date(json.verificationDate);
    this.patientInsuranceId = json.patientInsuranceId;
    return this;
  }
}
